export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7730.4975913f.jpg";